import { Maybe, UserDeliveryDetailFragment } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import {
  LotteryDeliveryForm,
  LotteryDeliveryValue,
} from './LotteryDeliveryForm'

export * from './fragments'

export type State = {
  user: Maybe<UserDeliveryDetailFragment>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (value: LotteryDeliveryValue) => Promise<void>
}

export const LotteryDeliveryInfoTemplate: Template<State, Action> = ({
  state,
  onSubmit,
}) => {
  const { t } = useTranslation('lotteryDeliveryInfo')
  const { routerNames } = useRouter()
  return (
    <BaseLayout margin header={{ back: true, title: t('title') }}>
      <Head title={routerNames.LotteryDeliveryInfo} />
      <LotteryDeliveryForm user={state.user} onSubmit={onSubmit} />
    </BaseLayout>
  )
}
